import React from 'react'
import { Button, ButtonGroup } from '@material-ui/core'
import { connect } from 'react-redux'
import { setSelectedCereal, setSelectedCerealSimulacion } from '../../actions/listados'
import { COLORES } from '../../../../config/colores'

/**
 * Componente para customToolbar en la tabla de Estimación semanal.
 * Con botones para seleccionar el cereal a visualizar.
 */
function OpcionesCerealEstimacion (props) {
  const { cerealesEstimacion, cerealActivo, setSelectedCereal, setSelectedCerealSimulacion } = props

  if (!cerealesEstimacion || cerealesEstimacion.length === 0) {
    return null
  }

  const handleCerealChange = (cereal) => {
    if (props.isSimulacionExportador) {
      setSelectedCerealSimulacion(cereal)
    } else {
      setSelectedCereal(cereal)
    }
  }

  return (
    <ButtonGroup
      aria-label='outlined primary button group'
      style={{ margin: '10px 0', flexWrap: 'wrap', flexDirection: 'column', justifyContent: 'center' }}
    >
      {cerealesEstimacion.map((cereal, index) => (
        <Button
          key={index}
          variant='contained'
          style={{
            color: cerealActivo === cereal ? 'white' : COLORES.blue.primary,
            backgroundColor: cerealActivo === cereal ? COLORES.blue.primary : 'white',
            fontWeight: 'bold',
            outline: 'none',
            margin: '5px',
            minWidth: '100px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            transition: 'background-color 0.3s ease, color 0.3s ease',
            '&:hover': {
              backgroundColor: cerealActivo === cereal ? COLORES.blue.dark : COLORES.blue.light
            }
          }}
          size='small'
          onClick={() => { handleCerealChange(cereal) }}
        >
          {cereal}
        </Button>

      ))}
    </ButtonGroup>
  )
}

const mapStateToProps = (state) => {
  return {
    cerealesEstimacion: state.stock.cerealesEstimacion,
    isSimulacionExportador: state.stock.isSimulacionExportador,
    cerealActivo: state.stock.cerealEstimacionStock
  }
}

const mapActionsToProps = {
  setSelectedCereal,
  setSelectedCerealSimulacion
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(OpcionesCerealEstimacion)
